import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useListItemStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    padding: '0.5em',
    border: '1px solid #000'
  },
  firstColumn: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    flexBasis: '25%'
  },
  codeListColumn: {
    display: 'flex',
    flexDirection: 'row',
    flexBasis: '25%',
    flex: 1
  }
});

const LookbackEncounterListItem = ({
  encounterId,
  isFinalized,
  isCurrentContract,
  dos,
  dxList,
  hccList,
  redirectToReviewDetails
}) => {
  const dosDate = new Date(dos);
  const displayDate = `${dosDate.getUTCMonth()+1}/${dosDate.getUTCDate()}/${dosDate.getUTCFullYear()}`;
  const reviewDetailsUrl = redirectToReviewDetails(encounterId);
  const classes = useListItemStyles();

  return (
    <div className={classes.root}>
      <div className={classes.firstColumn}>
        <span>DOS: {displayDate}</span>
        <span>Current Contract: {isCurrentContract.toString()}</span>
        <span>Finalized: {isFinalized.toString()}</span>
      </div>

      <div className={classes.codeListColumn}>
        <span>DX: {dxList.map(x => x.code).join(', ')}</span>
      </div>

      <div className={classes.codeListColumn}>
        <span>HCC: {hccList.map(x => x.code).join(', ')}</span>
      </div>
      <a href={reviewDetailsUrl} target="_blank">View</a>
    </div>
  );
};

LookbackEncounterListItem.propTypes = {
  encounterId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  isFinalized: PropTypes.bool.isRequired,
  isCurrentContract: PropTypes.bool.isRequired,
  dos: PropTypes.string.isRequired,
  dxList: PropTypes.array.isRequired,
  hccList: PropTypes.array.isRequired
};

const applyFilters = (encounters, dxFilterValue, hccFilterValue) => {
  let filteredEncounters = [...encounters];

  if (dxFilterValue.length > 0) {
    filteredEncounters = filteredEncounters.filter(x => {
      if (x.dxList && x.dxList.length > 0) {
        return x.dxList.filter(dx => {
          return dx.code.toUpperCase().indexOf(dxFilterValue.toUpperCase()) > -1;
        }).length > 0;
      }
    });
  }

  if (hccFilterValue.length > 0) {
    filteredEncounters = filteredEncounters.filter(x => {
      if (x.hccList && x.hccList.length > 0) {
        return x.hccList.filter(hcc => {
          return hcc.code
            .toUpperCase().indexOf(hccFilterValue.toUpperCase()) > -1;
        }).length > 0;
      }
    });
  }

  return filteredEncounters;
};

const Lookback = ({
  encounterList,
  dxFilterValue,
  hccFilterValue,
  handleLookbackFilterChange,
  redirectToReviewDetails
}) => {
  const filteredEncounters = applyFilters(
    encounterList.items,
    dxFilterValue,
    hccFilterValue
  );

  return (
    <div>
      <div>
        <h4 style={{ margin: '0', padding: '0.1em' }}>Filters</h4>
        <div>
          <label>Dx</label>
          <input
            style={{ margin: '0.8em 0 0 0.8em' }}
            value={dxFilterValue}
            onChange={e => handleLookbackFilterChange('dx', e.target.value)}
          />
        </div>

        <div>
          <label>HCC</label>
          <input
            style={{ margin: '0.8em 0 0 0.8em' }}
            value={hccFilterValue}
            onChange={e => handleLookbackFilterChange('hcc', e.target.value)}
          />
        </div>
      </div>

      <div style={{ margin: '0.8em 0 0 0', maxHeight:'610px', overflowY:'auto' }}>
        {
          filteredEncounters.length < 1
            ? <span>No encounters found</span>
            : (
              filteredEncounters.map(x => (
                <LookbackEncounterListItem
                  key={x.encounterId}
                  encounterId={x.encounterId}
                  isFinalized={x.isFinalized}
                  isCurrentContract={x.isCurrentContract}
                  dos={x.dos}
                  dxList={x.dxList}
                  hccList={x.hccList}
                  redirectToReviewDetails={redirectToReviewDetails}
                />
              ))
            )
        }
      </div>
    </div>
  );
};

Lookback.propTypes = {
  encounterList: PropTypes.shape({ items: PropTypes.array }).isRequired,
  dxFilterValue: PropTypes.string.isRequired,
  hccFilterValue: PropTypes.string.isRequired,
  handleLookbackFilterChange: PropTypes.func.isRequired
};

export default Lookback;
